import * as React from 'react';

export function useIsMobile(mobileBreakpoint = 768) {
	// `useSyncExternalStore` keeps SSR and client hydration in sync: React uses
	// `getServerSnapshot` (always `false` — the server has no viewport) for both the
	// server render *and* the client's first (hydration) render, so the markup matches
	// and no hydration mismatch (React #418) is thrown. It then switches to the live
	// `getSnapshot` value right after hydration and on every viewport change.
	//
	// Reading `window.innerWidth` in a `useState` initializer instead would return the
	// real value on the client's first render while the server rendered `false`, breaking
	// hydration for every viewport under the breakpoint (mobile users and mobile crawlers
	// such as Googlebot-Smartphone).
	const subscribe = React.useCallback(
		(callback: () => void) => {
			const mql = window.matchMedia(`(max-width: ${mobileBreakpoint - 1}px)`);
			mql.addEventListener('change', callback);
			return () => mql.removeEventListener('change', callback);
		},
		[mobileBreakpoint],
	);

	const getSnapshot = React.useCallback(() => window.innerWidth < mobileBreakpoint, [mobileBreakpoint]);

	return React.useSyncExternalStore(subscribe, getSnapshot, () => false);
}
